export const EMOJIS = [
    '😀', '😄', '😊', '🙂', '😉', '😍', '🤝', '👍',
    '👏', '🙏', '💪', '🎉', '✅', '❓', '💡', '📌',
    '🚀', '⚙️', '📊', '🗺️', '🏭', '💻', '⏰', '❤️',
];
//# sourceMappingURL=emojis.js.map